import React, { Component } from "react";
import '../../../static/css/popup.css';
import closeV2 from '../../../static/image/v2/popup/closeV2.png'
import {deleteShopImage} from "../../../static/js/service/shopService";
import {closePopup} from "../../../static/js/Common2";

class ChoiceMessagePopupV2 extends Component {
  render() {
    return (
      <div className="popupV2 ChoiceMessagePopup hide" id={this.props.id}>
        <div className="popupContainer">
          <div className="popupTitle">
            <h2>{this.props.title}</h2>
            <button className='closeBtn stopCloseBtn' onClick={() => closePopup(this.props.id)}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className="popupContent choicePopupText">
            {this.props.text}
          </div>
          <div className="popupBtn">
            <button className="closeBtn" onClick={() => closePopup(this.props.id)}>취소</button>
            {this.props.type !== "shopInfo2" &&
              <button className={`closeBtn blueBtn ${this.props.name}`}>확인</button>
            }
            {this.props.type === "shopInfo2" &&
              <button
                id="imgRemoveBtn2"
                className={`closeBtn blueBtn ${this.props.name}`}
                onClick={(e) => {
                  let dataId = e.target.getAttribute("data-id");
                  let shopId = e.target.getAttribute("data-shop");

                  deleteShopImage(dataId, shopId);
                }}
              >확인</button>
            }
          </div>
        </div>
      </div>
    )
  }
}

export { ChoiceMessagePopupV2 };